// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Menu, X, Shield } from 'lucide-react';
import '../styles/Navbar.css';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

   // Load Calendly script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleBookConsult = () => {
    if (window.Calendly) {
      window.Calendly.showPopupWidget('https://calendly.com/edsytech-info/30min');
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-content">
          <div className="navbar-logo">
            <a href='/'> <img title="Edsy Tech logo" className="logo" alt="Logo" src="/images/website.png"></img></a>
          </div>

          <div className="navbar-menu">
            <a href="/home" className="nav-link">Home</a>
            <a href="/home#solutions" className="nav-link">Solutions</a>
            <Link
              to="/products"
              className={`nav-link ${location.pathname.startsWith('/products') ? 'nav-link-active' : ''}`}
            >
              AI Products
            </Link>
            <Link
              to="/training"
              className={`nav-link ${location.pathname.startsWith('/training') ? 'nav-link-active' : ''}`}
            >
              Training
            </Link>
            <a href="/home#portfolio" className="nav-link">Portfolio</a>
            <a href="/home#insights" className="nav-link">Insights</a>
            <a
              href="/blog"
              className={`nav-link ${location.pathname.startsWith('/blog') ? 'nav-link-active' : ''}`}
            >
              Blog
            </a>
            <a href="/home#contact" className="nav-link">Contact</a>
           <button className="nav-cta-button" onClick={handleBookConsult}>
              Book Consult
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="mobile-menu-button"
          >
            {isMenuOpen ? <X className="icon" /> : <Menu className="icon" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-content">
            <a href="#home" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Home</a>
            <a href="#solutions" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Solutions</a>
            <Link
              to="/products"
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              AI Products
            </Link>
            <Link
              to="/training"
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Training
            </Link>
            <a href="#portfolio" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Portfolio</a>
            <a href="#insights" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Insights</a>
            <Link
              to="/blog"
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <a href="#contact" className="mobile-nav-link" onClick={() => setIsMenuOpen(false)}>Contact</a>
           <button className="mobile-nav-button" onClick={handleBookConsult}>
              Book Consult
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;